






































import {
  Component,
  Prop,
  Vue
} from "@/shared/vuepack";
import {
  AppBrowserTarget,
  isMobileApp,
  openUrl
} from "@/shared/mobileHelper";
import {
  FormDocumentPlan,
  FormDocumentType,
  HsabPlanType
} from "@/shared/types";
import { resourceDocumentIcon } from "@/shared/awesomeIconMapper";
import { useCustomerFormDocumentsStore } from "@/employee/store/customerFormDocument";

@Component({
  components: {}
})
export default class CustomerFormDocuments extends Vue {
  FormDocumentType = FormDocumentType;
  resourceDocumentIcon = resourceDocumentIcon;
  customerFormDocumentStore = useCustomerFormDocumentsStore();
  HsabPlanType = HsabPlanType;
  selectedPlanType: HsabPlanType = HsabPlanType.Unknown;

  @Prop()
  documentType: FormDocumentType;

  mounted () {
    this.customerFormDocumentStore.loadDocuments();
  }

  get documents () {
    if (this.customerFormDocumentStore.isLoaded) {
      if (this.selectedPlanType === HsabPlanType.Unknown) {
        return this.filteredDocuments;
      } else {
        return this.filteredDocuments
          .filter(doc => doc.planTypes.some(x => x.planType === this.selectedPlanType));
      }
    } else {
      return [];
    }
  }
  get filteredDocuments () {
    return this.customerFormDocumentStore.formDocuments
      .filter(x => x.formDocumentType === this.documentType);
  }
  get availablePlanTypes () {
    if (this.customerFormDocumentStore.isLoaded) {
      const hsaFirstSorting = (a: FormDocumentPlan, b: FormDocumentPlan) => {
        const first = HsabPlanType.HealthSavingAccount;
        return a.planType === first ? -1 : b.planType === first ? 1 : 0;
      };
      const distinctByPlanType = this.customerFormDocumentStore.availablePlanTypes.filter(
        (plan, i, p) => p.findIndex(t => t.planType === plan.planType) === i);
      return distinctByPlanType.sort(hsaFirstSorting);
    } else {
      return [];
    }
  }
  get hasMoreThanOnePlanType (): boolean {
    return this.documents.some(doc => doc.planTypes.length > 1);
  }
  get showPlanTypeFilterPills (): boolean {
    return this.documentType === FormDocumentType.Document
      && this.hasMoreThanOnePlanType;
  }
  planTypeName (pt: FormDocumentPlan) {
    const mapPlanTypeToName = (planType: HsabPlanType) => {
      switch (planType) {
        case HsabPlanType.Unknown:
          return "All Forms";
        case HsabPlanType.MedicalFlex:
          return "Medical FSA";
        case HsabPlanType.DependentCare:
          return "Dependent Care";
        case HsabPlanType.HealthReimbursementAccount:
          return "HRA";
        case HsabPlanType.HealthSavingAccount:
          return "HSA";
        case HsabPlanType.CommuterTransit:
          return "Commuter Transit";
        case HsabPlanType.CommuterParking:
          return "Commuter Parking";
        default:
          return planType;
      }
    };
    return mapPlanTypeToName(pt.planType);
  }
  selectPlanType (pt: HsabPlanType) {
    this.selectedPlanType = pt;
  }

  clickLink (event) {
    if (isMobileApp()) {
      openUrl(event.currentTarget.href, AppBrowserTarget.system);
    } else window.open(event.currentTarget.href, event.currentTarget.target);
  }
}
